<form *ngIf="templatesMap" [formGroup]="dynamicFormModel.formGroup" class="flex flex-col mat-headline-6 dynamic-form" #ngForm="ngForm">
  <ng-container [ngTemplateOutlet]="templatesMap[dynamicFormModel.property.type]"
    [ngTemplateOutletContext]="{control: dynamicFormModel.formGroup.get(dynamicFormModel.property.name), property: dynamicFormModel.property, formGroup: dynamicFormModel.formGroup, showTitle: showTopLevelTitle}"></ng-container>
</form>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.BOOLEAN" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
<div class="flex flex-col form-field boolean-field" [ngClass]="{'left-column': (index % 2)}">
    <div *ngIf="showTitle" class="flex flex-row mb-4">
      <label>{{ property.title | uppercase }}</label>
      <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="right" matTooltipPosition="right" [matTooltip]="property.description" class="info-icon"></mat-icon>
      <span *ngIf="property.required" class="mandatory mt--6 mat-body-2">*</span>
    </div>
    <mat-slide-toggle color="primary" [formControl]="setProperties(control, property.default, 'boolean', property)" [disabled]="property?.updatedValue"></mat-slide-toggle>  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.STRING" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
  <div class="flex flex-col form-field" [ngClass]="{'left-column': (index % 2)}">
    <div *ngIf="showTitle" class="flex flex-row mb-4">
      <label>{{ property.title | uppercase }}</label>
      <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="right" matTooltipPosition="right" [matTooltip]="property.description" class="info-icon"></mat-icon>
      <span *ngIf="property.required" class="mandatory mt--6 mat-body-2">*</span>
    </div>
    <input class="blend-border" *ngIf="property.default" [formControl]="setProperties(control, property.default)" [required]="property.mandatory" [readonly]="property?.updatedValue">
    <input class="blend-border" *ngIf="!property.default" [placeholder]="!property.secretField ? (property.placeholder || 'SERVICE.ENTER' | transloco: { propertyName: property.title}) : ' '" [formControl]="control" [required]="property.mandatory" [readonly]="property?.updatedValue">
    <app-error [control]="control"></app-error>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.SELECT" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
  <div class="form-field" [ngClass]="{'left-column': (index % 2)}">
    <div *ngIf="showTitle" class="flex flex-row mb-4">
      <label>{{ property.title | uppercase }}</label>
      <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="right" matTooltipPosition="right" [matTooltip]="property.description" class="info-icon"></mat-icon>
      <span *ngIf="property.required" class="mandatory mt--6 mat-body-2">*</span>
    </div>
    <select class="blend-border" [formControl]="setProperties(control, property.default)" [ngClass]="{ 'placeholder': control.value === null, 'readonly': property?.updatedValue }">
      <option [ngValue]="null" *ngIf="!property.default" [disabled]="true" hidden>{{ property.placeholder || 'SERVICE.SELECT' | transloco: { propertyName: property.title } }}</option>
      <option *ngFor="let value of property.enum" [value]="value">{{ value }}</option>
    </select>
    <app-error [control]="control"></app-error>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.DATE" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
  <div class="form-field" [formGroup]="formGroup" [ngClass]="{'left-column': (index % 2)}">
    <div class="flex flex-row mb-4" *ngIf="showTitle">
      <label>{{ property.title | uppercase }}</label>
      <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="right" matTooltipPosition="right" [matTooltip]="property.description" class="info-icon"></mat-icon>
      <span *ngIf="property.required" class="mandatory mt--6 mat-body-2">*</span>
    </div>
    <app-datepicker [control]="setProperties(control, property.default)" [placeholder]="property.placeholder || 'SERVICE.SELECT' | transloco: { propertyName: property.title }" [ngClass]="{'readonly': property?.updatedValue}"></app-datepicker>
    <app-error [control]="control"></app-error>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.INTEGER" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
  <div class="flex flex-col form-field" [ngClass]="{'left-column': (index % 2)}">
    <div class="flex flex-row mb-4" *ngIf="showTitle">
      <label>{{ property.title | uppercase }}</label>
      <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="right" matTooltipPosition="right" [matTooltip]="property.description" class="info-icon"></mat-icon>
      <span *ngIf="property.required" class="mandatory mr-- mat-body-2">*</span>
    </div>
    <input class="blend-border" *ngIf="property.default" [formControl]="setProperties(control, property.default)" [required]="property.mandatory" appNumeric allowNegative="true" [readonly]="property?.updatedValue">
    <input type="text" class="blend-border" *ngIf="!property.default" [placeholder]="property.placeholder || 'SERVICE.ENTER' | transloco: { propertyName: property.title }" [formControl]="control" [required]="property.mandatory" appNumeric allowNegative="true" [readonly]="property?.updatedValue">
    <app-error [control]="control"></app-error>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.NUMBER" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
  <div class="flex flex-col form-field" [ngClass]="{'left-column': (index % 2)}">
    <div *ngIf="showTitle" class="flex flex-row mb-4">
      <label>{{ property.title | uppercase }}</label>
      <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="right" matTooltipPosition="right" [matTooltip]="property.description" class="info-icon"></mat-icon>
      <span *ngIf="property.required" class="mandatory mt--6 mat-body-2">*</span>
    </div>
    <input class="blend-border" *ngIf="property.default" [formControl]="setProperties(control, property.default)" [required]="property.mandatory" appNumeric allowNegative="true" [decimals]="16" [readonly]="property?.updatedValue">
    <input type="text" class="blend-border" *ngIf="!property.default" [placeholder]="property.placeholder || 'SERVICE.ENTER' | transloco: { propertyName: property.title }" [formControl]="control" [required]="property.mandatory" appNumeric allowNegative="true" [decimals]="16" [readonly]="property?.updatedValue">
    <app-error [control]="control"></app-error>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.OBJECT" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup">
  <div [formGroup]="formGroup.get(property.name)">

    <ng-container *ngFor="let nestedproperty of property.properties; let i = index" [ngTemplateOutlet]="templatesMap[nestedproperty.type]"
      [ngTemplateOutletContext]="{
        control: formGroup.get(property.name).get(nestedproperty.name),
        property: nestedproperty,
        formGroup: formGroup.get(property.name),
        showTitle: true,
        index: i + 1
      }"></ng-container>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.ARRAY" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
  <div class="flex flex-col form-field" [ngClass]="{'left-column': (index % 2)}">
    <div class="flex flex-row mb-4" *ngIf="showTitle">
      <label>{{ property.title | uppercase }}</label>
      <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="right" matTooltipPosition="right" [matTooltip]="property.description" class="info-icon"></mat-icon>
      <span *ngIf="property.required" class="mandatory mt--6 mat-body-2">*</span>
    </div>

    <ng-container *ngIf="property.items?.enum; else freeTypeArray">
      <!-- <mat-select #matSelect [placeholder]="property.placeholder || 'SERVICE.SELECT' | transloco: { propertyName: property.title }" [formControl]="setProperties(control, property.default)" [ngClass]="{ 'placeholder': control.value === null, 'readonly': disableMultiselectField(property) }" multiple>
        <mat-option *ngFor="let tag of property.items.enum" [value]="tag" [disabled]="selectedValues(tag, property)">{{tag}}</mat-option>
      </mat-select> -->
      <mat-select class="drop-down" #matSelect [placeholder]="property.placeholder || 'SERVICE.SELECT' | transloco: { propertyName: property.title }" [formControl]="setMultiSelectProperties(control, property.default)" [ngClass]="{ 'placeholder': control.value === null}" multiple>
        <mat-option [ngClass]="{'select-option': disableMultiselectField(property) }"*ngFor="let tag of property.items.enum" [value]="tag" [disabled]="selectedValues(tag, property)">{{tag}}</mat-option>
      </mat-select>
    </ng-container> 

    <ng-template #freeTypeArray>
      <mat-form-field appearance="outline">
        <mat-chip-list #chipList>
          <mat-chip *ngFor="let tag of control.value; let i = index;"
                    [removable]="true"
                    (removed)="removeTag(i, control)"
                    class="tags word-break-word fw-400">
            <div class="tag-content">{{tag}}</div>
            <mat-icon svgIcon="close" class="cursor-pointer cross-icon" matChipRemove></mat-icon>
          </mat-chip>
          <input *ngIf="property.items.type === propertyType.STRING" [required]="property.mandatory"
          [matChipInputFor]="chipList"
          [matChipInputAddOnBlur]="true"
          (matChipInputTokenEnd)="addTag($event, control)"
          class="hidden-input"
          autocomplete="off">
        </mat-chip-list>
      </mat-form-field>
    </ng-template>
    <app-error [control]="control"></app-error>
  </div>
</ng-template>
